import { Nullable } from 'utils/types';
import Task from '../Task';
export interface State {
  isLoading: boolean;
  error: Nullable<string>;
  tasks: Task[];
}

export interface Action<TPayload = unknown> {
  type: Actions;
  payload: TPayload;
}

export enum Actions {
  RESET = 'CM/TASKS/RESET',

  SET_TASKS_PENDING = 'CM/TASKS/SET/PENDING',
  SET_TASKS_FINISH = 'CM/TASKS/SET/FINISH',
  SET_TASKS_ERROR = 'CM/TASKS/SET/ERROR',

  SET_TASK_ACTION_IN_PROGRESS = 'CM/TASKS/ACTION/IN_PROGRESS',
  SET_TASK_ACTION_FINISH = 'CM/TASKS/ACTION/FINISH',
  SET_TASK_STATUS_COMPLETED = 'CM/TASKS/TASK/SET_STATUS/COMPLETED',
  SET_TASK_STATUS_NOT_APPLICABLE = 'CM/TASKS/TASK/SET_STATUS/NOT_APPLICABLE',
  SET_TASK_STATUS_TODO = 'CM/TASKS/TASK/SET_STATUS/TODO',
}

export const createState = (): State => ({
  isLoading: false,
  error: null,
  tasks: [],
});
